<template>
  <v-hover v-slot="{ hover }">
    <router-link
      :to="{ name: 'launcher', params: {game: game.gameUid, casino: casino }}"
    >
      <v-avatar
        class="game"
        :color="game.image ? 'transparent' : 'secondary'"
        :size="hover ? '20vh' : '18vh'"
      >
          <v-img v-if="game.image"
            contain
            :src=game.image
            :alt=game.label
          />
          <span v-else class="white--text">
              {{ game.label }}
          </span>
      </v-avatar>
    </router-link>
  </v-hover>
</template>

<script>
export default {
  name: 'Game',
  props: {
    game: {
      type: Object,
      required: true,
      default: () => {},
    },
    casino: {
      type: String,
      required: true,
      default: '',
    },
  },
  data: () => ({
  }),
};
</script>

<style scoped>
 .game {
   transition: .3s;
 }

</style>
